import { render } from "./areasComponent.vue?vue&type=template&id=6224ed40&scoped=true"
const script = {}

import "./areasComponent.vue?vue&type=style&index=0&id=6224ed40&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\HP\\Desktop\\Proyectos Vue.js\\version-produccion-iquela\\Dashboard_usuarios\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6224ed40"]])

export default __exports__